import { ACTIVE_PROMOTION_COUPON_TYPE, getProductBundleType, getRightBundleLevel, PricingModalOrigin } from '@wegic/price-ui';
import { getResolvedPricingTrackingOriginFromStorage } from '@/modules/Subscribe/trackingContext';
import { useUserStore } from '@/stores/user';
const CREDITS_MODAL_RIGHTS = 'credits_modal';
const REMIX_CREDITS_BILL_REASON = 'remix_credits';
const CREDITS_BILL_REASON = 'credits';
export const COUPON_EVENT = {
    SHOW: 'coupon_code_show',
    COPY: 'coupon_code_copy'
};
function isRecord(value) {
    return !!value && typeof value === 'object';
}
export function getPaymentFailReason(error, errorToastKey) {
    if (!isRecord(error)) {
        return errorToastKey || 'unknown';
    }
    const reason = error.msg || error.message || error.msg_cn;
    return typeof reason === 'string' && reason ? reason : errorToastKey || 'unknown';
}
export function getPaymentFailCode(error) {
    if (!isRecord(error)) {
        return undefined;
    }
    const dataCode = isRecord(error.data) ? error.data.code : undefined;
    const normalizedCode = Number(error.code ?? dataCode);
    return Number.isFinite(normalizedCode) ? normalizedCode : undefined;
}
function getCouponTrackingPayload(data) {
    if (!data.couponApplied) {
        return {};
    }
    return {
        coupon_type: ACTIVE_PROMOTION_COUPON_TYPE,
        ...data.couponCode ? {
            coupon_code: data.couponCode
        } : {}
    };
}
export function getCreditPurchaseTrackingContext(data) {
    let rights = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CREDITS_MODAL_RIGHTS;
    return {
        rights,
        ...getCouponTrackingPayload(data)
    };
}
export function getCreditPurchaseSuccessTrackingContext(data, rights) {
    return {
        ...getCreditPurchaseTrackingContext(data, rights ?? CREDITS_MODAL_RIGHTS),
        bill_reason: CREDITS_BILL_REASON,
        plan: getCreditPurchasePlanKey(useUserStore.getState().userSubscription)
    };
}
export function getCreditPurchasePlanKey(userSubscription) {
    const currentProduct = userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.currentProduct;
    if (!(userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.exist) || !currentProduct) {
        return 'rc';
    }
    const currentBundleLevel = getRightBundleLevel(getProductBundleType(currentProduct));
    if (currentBundleLevel >= 2) {
        return 'pc';
    }
    if (currentBundleLevel >= 1) {
        return 'bc';
    }
    return 'rc';
}
export function getRemixCreditPurchaseTrackingContext() {
    return {
        rights: PricingModalOrigin.RemixPlanModelCredits,
        bill_reason: REMIX_CREDITS_BILL_REASON,
        plan: getCreditPurchasePlanKey(useUserStore.getState().userSubscription)
    };
}
function getCouponTrackingContext(coupon, origin) {
    return {
        coupon_code: coupon.code,
        coupon_type: coupon.type || ACTIVE_PROMOTION_COUPON_TYPE,
        origin
    };
}
// 优惠券展示/复制在多个弹窗复用，事件名和 origin 在调用处决定
export function collectCouponEvent(event, origin, coupon) {
    collect(event, getCouponTrackingContext(coupon, origin));
}
export function getUpgradeModalPaymentTrackingContext(data, checkoutRights) {
    return {
        origin: getResolvedPricingTrackingOriginFromStorage(checkoutRights ?? null),
        rights: checkoutRights ?? null,
        bill_reason: 'upgrade',
        ...getCouponTrackingPayload(data)
    };
}
